import * as yup from "yup";
import { Validations } from "../../config";
export const changePasswordSchema = yup.object().shape({
  currentPassword: Validations.password,
  password: Validations.password,
  passwordConfirmation: Validations.password,
});
